// The document color palette. Colors are stored in content as var(--doc-*)
// references (the server sanitizer whitelists exactly this shape), so text
// keeps readable contrast in both themes — the tokens live in index.css.
export type DocumentColor = {
  id: string;
  labelKey: string;
  value: string;
};

export const documentTextColors: DocumentColor[] = [
  { id: "gray", labelKey: "colors.gray", value: "var(--doc-text-gray)" },
  { id: "brown", labelKey: "colors.brown", value: "var(--doc-text-brown)" },
  { id: "orange", labelKey: "colors.orange", value: "var(--doc-text-orange)" },
  { id: "yellow", labelKey: "colors.yellow", value: "var(--doc-text-yellow)" },
  { id: "green", labelKey: "colors.green", value: "var(--doc-text-green)" },
  { id: "blue", labelKey: "colors.blue", value: "var(--doc-text-blue)" },
  { id: "purple", labelKey: "colors.purple", value: "var(--doc-text-purple)" },
  { id: "red", labelKey: "colors.red", value: "var(--doc-text-red)" },
];

export const documentHighlightColors: DocumentColor[] = [
  { id: "gray", labelKey: "colors.gray", value: "var(--doc-hl-gray)" },
  { id: "orange", labelKey: "colors.orange", value: "var(--doc-hl-orange)" },
  { id: "yellow", labelKey: "colors.yellow", value: "var(--doc-hl-yellow)" },
  { id: "green", labelKey: "colors.green", value: "var(--doc-hl-green)" },
  { id: "blue", labelKey: "colors.blue", value: "var(--doc-hl-blue)" },
  { id: "purple", labelKey: "colors.purple", value: "var(--doc-hl-purple)" },
  { id: "red", labelKey: "colors.red", value: "var(--doc-hl-red)" },
];
